if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];

      constructor() {
        super();

        this.quantityInput = this.querySelector('.quantity__input');
      }

      connectedCallback() {
        this.initializeProductSwapUtility();

        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );

        this.initQuantityHandlers();
        this.dispatchEvent(new CustomEvent('product-info:loaded', { bubbles: true }));
      }

      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;

        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) =>
          html.querySelectorAll('.scroll-trigger').forEach((element) => element.classList.add('scroll-trigger--cancel'))
        );
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
        if (!this.contains(event.target)) return;

        this.resetProductFormState();

        const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
        this.pendingRequestUrl = productUrl;
        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct;

        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
            : this.handleUpdateProductInfo(productUrl),
        });
      }

      resetProductFormState() {
        const productForm = this.productForm;
        productForm?.toggleSubmitButton(true);
        productForm?.handleErrorMessage();
      }

      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          this.productModal?.remove();

          const selector = updateFullPage ? "product-info[id^='MainProduct']" : 'product-info';
          const variant = this.getSelectedVariant(html.querySelector(selector));
          this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;

            HTMLUpdateUtility.viewTransition(
              document.querySelector('main'),
              html.querySelector('main'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector('product-info'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }
        };
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            callback(html);
          })
          .then(() => {
            // set focus to last clicked option value
            document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
              console.log('Fetch aborted by user');
            } else {
              console.error(error);
            }
          });
      }

      getSelectedVariant(productInfoNode) {
        const selectedVariant = productInfoNode.querySelector('variant-selects [data-selected-variant]')?.innerHTML;
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }

      buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(',')}`);
        }

        return `${url}?${params.join('&')}`;
      }

      updateOptionValues(html) {
        const variantSelects = html.querySelector('variant-selects');
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks);
        }
      }

      handleUpdateProductInfo(productUrl) {
        return (html) => {
          const variant = this.getSelectedVariant(html);

          this.pickupAvailability?.update(variant);
          this.updateOptionValues(html);
          this.updateURL(productUrl, variant?.id);
          this.updateVariantInputs(variant?.id, variant);
          

          
          if (!variant) {
            this.setUnavailable();
            return;
          }

          this.updateMedia(html, variant?.featured_media?.id);

          if( !variant.available){
            this.autoSelectAvailableOptions();
          }
          
          const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(`#${id}-${this.dataset.section}`);
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle('hidden', shouldHide(source));
            }
          };

// const updateSourceFromDestination = (id, shouldHide = () => false) => {
//   const source = html.getElementById(`${id}-${this.sectionId}`);
//   const destination = this.querySelector(`#${id}-${this.dataset.section}`);

//   // ✅ HARD SAFETY
//   if (!source || !destination) {
//     console.warn(`Missing element: ${id}`);
//     return;
//   }

//   destination.innerHTML = source.innerHTML;

//   // ✅ SAFE CALL
//   try {
//     destination.classList.toggle('hidden', shouldHide(source));
//   } catch (e) {
//     console.warn(`Error in shouldHide for ${id}`, e);
//   }
// };

          updateSourceFromDestination('price');
          updateSourceFromDestination('Sku', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('Inventory', ({ innerText }) => innerText === '');
          updateSourceFromDestination('Volume');
          updateSourceFromDestination('Price-Per-Item', ({ classList }) => classList.contains('hidden'));

          this.updateQuantityRules(this.sectionId, html);
          this.querySelector(`#Quantity-Rules-${this.dataset.section}`)?.classList.remove('hidden');
          this.querySelector(`#Volume-Note-${this.dataset.section}`)?.classList.remove('hidden');

          this.productForm?.toggleSubmitButton(
            html.getElementById(`ProductSubmitButton-${this.sectionId}`)?.hasAttribute('disabled') ?? true,
            window.variantStrings.soldOut
          );

          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });

          if (typeof StampedFn !== "undefined" && typeof StampedFn.reloadUGC === "function") {
              StampedFn.reloadUGC();
          }     

        };
      }



      // autoSelectAvailableOptions() {
        
      //   const QuantityOptions = this.querySelectorAll('.productVraintBox .inputBox_outer');
      //   const FlavouredOptions = this.querySelectorAll('.product-form__input--dropdown');
      //   if (QuantityOptions.length == 0) return
      //   if (FlavouredOptions.length == 0) return

        
      //   if( QuantityOptions[0].classList.contains('disabled-variant') ){
      //      QuantityOptions[1].querySelector('label').click();
      //      QuantityOptions[1].dispatchEvent(new Event('click', { bubbles: true }));
      //   }else if(QuantityOptions[1].classList.contains('disabled-variant')){
      //     QuantityOptions[2].querySelector('label').click();
      //     QuantityOptions[2].dispatchEvent(new Event('click', { bubbles: true }));
      //   }else if(QuantityOptions[2].classList.contains('disabled-variant')){
      //     QuantityOptions[3].querySelector('label').click();
      //     QuantityOptions[3].dispatchEvent(new Event('click', { bubbles: true }));
      //   }else if(QuantityOptions[3].classList.contains('disabled-variant')){
      //     QuantityOptions[4].querySelector('label').click();
      //     QuantityOptions[4].dispatchEvent(new Event('click', { bubbles: true }));
      //   }else if(QuantityOptions[4].classList.contains('disabled-variant')){
      //     QuantityOptions[5].querySelector('label').click();
      //     QuantityOptions[5].dispatchEvent(new Event('click', { bubbles: true }));
      //   }else if(QuantityOptions[5].classList.contains('disabled-variant')){
      //     QuantityOptions[6].querySelector('label').click();
      //     QuantityOptions[6].dispatchEvent(new Event('click', { bubbles: true }));
      //   }
      // }



      autoSelectAvailableOptions() {
        const QuantityOptions = this.querySelectorAll('.productVraintBox .inputBox_outer');
        const FlavouredOptions = this.querySelectorAll('.product-form__input--dropdown');
        if (QuantityOptions.length == 0) return
        if (FlavouredOptions.length == 0) return

        for (let i = 0; i < QuantityOptions.length; i++) {
          if (QuantityOptions[i].classList.contains('disabled-variant')) {
            const next = QuantityOptions[i + 1];
            if (next) {
              const label = next.querySelector('label');
              if (label) {
                label.click();
                next.dispatchEvent(new Event('click', { bubbles: true }));
              }
            }
            break;
          }
        }
      }

      updateVariantInputs(variantId,vmain) {
        this.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        ).forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          const skuInput = productForm?.querySelector('#sku-min');
          if( skuInput ){ skuInput.value = vmain.sku ?? ''; }
          input.value = variantId ?? '';
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      updateURL(url, variantId) {
        this.querySelector('share-button')?.updateUrl(
          `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ''}`
        );

        if (this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);
      }

      setUnavailable() {
        this.productForm?.toggleSubmitButton(true, window.variantStrings.unavailable);

        const selectors = ['price', 'Inventory', 'Sku', 'Price-Per-Item', 'Volume-Note', 'Volume', 'Quantity-Rules']
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(', ');
        document.querySelectorAll(selectors).forEach(({ classList }) => classList.add('hidden'));
      }

      updateMedia(html, variantFeaturedMediaId) {
        // if (!variantFeaturedMediaId) return;
        const mediaGallerySource = this.querySelector('media-gallery ul');
        const mediaGalleryDestination = html.querySelector(`media-gallery ul`);

        const refreshSourceData = () => {
          if (this.hasAttribute('data-zoom-on-hover')) enableZoomOnHover(2);
          const mediaGallerySourceItems = Array.from(mediaGallerySource.querySelectorAll('li[data-media-id]'));
          const sourceSet = new Set(mediaGallerySourceItems.map((item) => item.dataset.mediaId));
          const sourceMap = new Map(
            mediaGallerySourceItems.map((item, index) => [item.dataset.mediaId, { item, index }])
          );
          return [mediaGallerySourceItems, sourceSet, sourceMap];
        };

        if (mediaGallerySource && mediaGalleryDestination) {
          let [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
          const mediaGalleryDestinationItems = Array.from(
            mediaGalleryDestination.querySelectorAll('li[data-media-id]')
          );
          const destinationSet = new Set(mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId));
          let shouldRefresh = false;

          // add items from new data not present in DOM
          for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
            if (!sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)) {
              mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
              shouldRefresh = true;
            }
          }

          // remove items from DOM not present in new data
          for (let i = 0; i < mediaGallerySourceItems.length; i++) {
            if (!destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)) {
              mediaGallerySourceItems[i].remove();
              shouldRefresh = true;
            }
          }

          // refresh
          if (shouldRefresh) [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();

          // if media galleries don't match, sort to match new data order
          mediaGalleryDestinationItems.forEach((destinationItem, destinationIndex) => {
            const sourceData = sourceMap.get(destinationItem.dataset.mediaId);

            if (sourceData && sourceData.index !== destinationIndex) {
              mediaGallerySource.insertBefore(
                sourceData.item,
                mediaGallerySource.querySelector(`li:nth-of-type(${destinationIndex + 1})`)
              );

              // refresh source now that it has been modified
              [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
            }
          });
        }

        // set featured media as active in the media gallery
        this.querySelector(`media-gallery`)?.setActiveMedia?.(
          `${this.dataset.section}-${variantFeaturedMediaId}`,
          true
        );

        if( this.querySelector(`#inventory___min`) ){
          this.querySelector(`#inventory___min`).value = html.querySelector(`#inventory___min`).value;
        }

        // update media modal
        const modalContent = this.productModal?.querySelector(`.product-media-modal__content`);
        const newModalContent = html.querySelector(`product-modal .product-media-modal__content`);
        if (modalContent && newModalContent) modalContent.innerHTML = newModalContent.innerHTML;

       if( html.querySelectorAll('.flavour_prod_info').length > 0 && document.querySelectorAll('.flavour_prod_info').length > 0 ){
          document.querySelector('.flavour_prod_info').innerHTML = html.querySelector('.flavour_prod_info').innerHTML;
        }
        
       const newTitles = html.querySelectorAll('.variant_meta_title');
       const currentTitles = document.querySelectorAll('.variant_meta_title');
        
        if (newTitles.length > 0 && currentTitles.length > 0) {
          currentTitles.forEach((el, i) => {
            if (newTitles[i]) {
              el.innerHTML = newTitles[i].innerHTML;
            }
          });
        }

     
        
        document.querySelector('.product-gallery-container').innerHTML = html.querySelector('.product-gallery-container').innerHTML;
        setTimeout(() => {
          var MediaThumbnailView = new Swiper('.swiper.thumb-swiper.Thumbnail', {
            slidesPerView: 6,
            direction: 'vertical',
            spaceBetween: 10,
            loop: false,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            on: {
              init: (swiper) => {
                    if ( document.querySelector('.thumb-swiper.Thumbnail').querySelector('.swiper-wrapper').childElementCount > 6 && window.screen.width > 749 ) {
                      document.querySelector('.thumb-slider-wrapper').classList.remove('WpNotScrolledInherit');
                      if (window.screen.width > 749 ){
                        let totalGap = swiper.slides[0].clientHeight * swiper.passedParams.slidesPerView;
                        totalGap = parseInt(totalGap + 50);
                        document.querySelector('.swiper.thumb-swiper.Thumbnail').style.height = totalGap + 'px';
                        window.addEventListener('resize', () => {
                          let totalGap = swiper.slides[0].clientHeight * swiper.passedParams.slidesPerView;
                          totalGap = parseInt(totalGap + 50);
                          document.querySelector('.swiper.thumb-swiper.Thumbnail').style.height = totalGap + 'px';
                        });
                      }
                    } else if( window.screen.width > 749 ) {
                        if (window.screen.width > 749 ){
                          document.querySelector('.thumb-slider-wrapper').classList.add('WpNotScrolledInherit');
                          if(swiper.slides[0] ){
                            let totalGap = swiper.slides[0].clientHeight * swiper.passedParams.slidesPerView;
                            totalGap = parseInt(totalGap + 65);
                            document.querySelector('.swiper.thumb-swiper.Thumbnail').style.height = totalGap + 'px';
                            window.addEventListener('resize', () => {
                              let totalGap = swiper.slides[0].clientHeight * swiper.passedParams.slidesPerView;
                              totalGap = parseInt(totalGap + 65);
                              document.querySelector('.swiper.thumb-swiper.Thumbnail').style.height = totalGap + 'px';
                            });
                          }
                        }
                    }
              }
            }
          });
          var MediaMainProductView = new Swiper('.swiper.main-swiper.MainImage', {
            autoHeight: true,
            centeredSlides: false,
            loop: false,
            slidesPerView: 1,
            spaceBetween: 15,
            navigation: { nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' },
            pagination: {
              el: '.swiper-pagination',
              clickable: true,
            },
            thumbs: { swiper: MediaThumbnailView },
          });
        }, 200);

        if( document.querySelectorAll('.main-swiper.MainImage .image_mainslide img').length > 0 ){
          function enableZoom(imgElement) {
              const container = imgElement.parentElement;
              container.classList.add('zoom-container');
              let magnifiedView = container.querySelector('.magnified-view');
              if (!magnifiedView) {
                  magnifiedView = document.createElement('div');
                  magnifiedView.className = 'magnified-view';
                  container.appendChild(magnifiedView);
              }
              const originalImage = imgElement;
              magnifiedView.style.backgroundImage = `url(${originalImage.src})`;
              magnifiedView.style.transitionDuration = '0ms'; 
              magnifiedView.style.transform = 'translate3d(0px, 0px, 0px) scale(1)';
              magnifiedView.style.opacity = '0';
              magnifiedView.style.transformOrigin = '50% 50%';
              magnifiedView.style.display = 'none';
              container.addEventListener('mousemove', (e) => {
                  magnifiedView.style.display = 'block';
                  const rect = originalImage.getBoundingClientRect();
                  const x = e.clientX - rect.left;
                  const y = e.clientY - rect.top;
                  const xPercent = (x / rect.width) * 100;
                  const yPercent = (y / rect.height) * 100;
                  magnifiedView.style.transformOrigin = `${xPercent}% ${yPercent}%`;
                  magnifiedView.style.transitionDuration = '0ms';
                  magnifiedView.style.opacity = '1';
                  magnifiedView.style.transform = 'translate3d(0px, 0px, 0px) scale(2)'; 
              });
              container.addEventListener('mouseleave', () => {
                  magnifiedView.style.transitionDuration = '150ms';
                  magnifiedView.style.transform = 'translate3d(0px, 0px, 0px) scale(1)';
                  magnifiedView.style.opacity = '0';
                  setTimeout(() => {
                      magnifiedView.style.display = 'none';
                  }, 150);
              });
          }
          document.querySelectorAll('.main-swiper.MainImage .image_mainslide img').forEach(img => {
              if (window.innerWidth > 749) {
                  enableZoom(img);
              }
          });
        }
        
        if( document.querySelectorAll('.wb-product-image-slider__zoom').length > 0 ){
              document.querySelectorAll('.wb-product-image-slider__zoom').forEach((el)=>{
                el.addEventListener('click', (tg)=>{
                  tg.preventDefault();
                  const activeSlide = document.querySelector('.main-swiper.MainImage')?.querySelector('.swiper-slide.swiper-slide-active');
                  if (!activeSlide) return;
                  const imageElement = activeSlide.querySelector('img');
                  if (!imageElement) return;
                  let imagePinchZoomImg = imageElement.getAttribute('data-src') || imageElement.getAttribute('src');
                  const wrapper = document.querySelector('.pinchZoomMobile__wrapper');
                  const zoomImg = document.querySelector('.wb-product-zoom-mobile__img');
                  const pinchElement = document.querySelector('.pinchZoomMobile__mb__pinch');
                  const containerElZoom = document.querySelector('.pinchZoomMobile__mb__pinch__wp');
                  if (wrapper && zoomImg && pinchElement) {
                      wrapper.classList.add('active');
                      zoomImg.setAttribute('src', imagePinchZoomImg);
                      if (PinchZoom && PinchZoom.default) {
                        new PinchZoom.default(containerElZoom, {
                          draggableUnzoomed: true,
                          maxZoom: 4,
                          minZoom: 1,
                        });
                      } else {
                        console.error('PinchZoom is not available.');
                      }             
                  }
                })
              });

              document.querySelectorAll('.pinchZoomMobile__cross').forEach((el)=>{
                el.addEventListener('click', (tg)=>{
                  tg.preventDefault();
                  const wrapper = document.querySelector('.pinchZoomMobile__wrapper');
                  const zoomImg = document.querySelector('.wb-product-zoom-mobile__img');
                  if (wrapper) wrapper.classList.remove('active');
                  if (zoomImg) zoomImg.setAttribute('src', '');
                })
              });       
          }         
        
        if( html.querySelectorAll('.product_meta_sku').length > 0 ){
          document.querySelector('.product_meta_sku').innerHTML = html.querySelector('.product_meta_sku').innerHTML;
        }
        // console.log("Target AFTER update:", document.querySelector('.additional_productinformation').innerHTML);

        if ( !html.querySelector('.aditoInfo-box-description').childElementCount == 0 ){
          document.querySelector('.additional_productinformation').innerHTML = html.querySelector('.additional_productinformation').innerHTML;
        }

        document.querySelectorAll('.product-form__input select').forEach((select) => {
          select.addEventListener('change', () => {
            const variantDiv = document.querySelector('.productVraintBox div[variant-add]');
            
            if (variantDiv) {
              const input = variantDiv.querySelector('input[type="radio"]');
        
              // Only trigger if not already selected and not disabled
              if (input && !input.checked && !input.disabled) {
                input.click();
                input.dispatchEvent(new Event('click', { bubbles: true }));
              }
            }
          });
        });
         const firstVariant = document.querySelector(".productVraintBox .first-variant-300g");

          if (firstVariant) {
            firstVariant.addEventListener("click", function () {
              // Find the hidden variant input
              const hiddenVariant = document.querySelector(".variant-300g.hidden input[type='radio']");
              
              if (hiddenVariant) {
                hiddenVariant.checked = true;
                hiddenVariant.dispatchEvent(new Event('change', { bubbles: true }));
              }
            });
          }     
  
         document.querySelectorAll('.tab-a').forEach((elm)=>{
           elm.addEventListener('click', (target)=>{
             target.preventDefault();
              let tabId = target.currentTarget.dataset.id;
              document.querySelectorAll('.tab-a').forEach((elm)=>{ elm.classList.remove('active-a') });
              document.querySelectorAll('.content_tabs .tab').forEach((elm)=>{ elm.classList.remove('tab-active') });
              target.currentTarget.classList.add('active-a');
              document.querySelector(`.content_tabs .tab[data-id="${tabId}"]`).classList.add('tab-active');
             const targetTabContent = document.querySelector(`.content_tabs .tab[data-id="${tabId}"]`);
             // jQuery scroll to content tab if .product_tab_sticky exists
             if (document.querySelector('.product_tab_sticky') && targetTabContent) {
                const offset = 50; // Adjust if needed for sticky headers
                const tabTop = targetTabContent.getBoundingClientRect().top + window.pageYOffset - offset;
                window.scrollTo({
                  top: tabTop,
                  behavior: "smooth"
                });
              }
              const isMobile = window.innerWidth <= 768;
              if (isMobile) {
                target.currentTarget.scrollIntoView({
                  behavior: "smooth",
                  inline: "center",
                  block: "nearest"
                });
              }
           })
         })
        
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity ? parseInt(this.quantityInput.dataset.cartQuantity) : 0,
          min: this.quantityInput.dataset.min ? parseInt(this.quantityInput.dataset.min) : 1,
          max: this.quantityInput.dataset.max ? parseInt(this.quantityInput.dataset.max) : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.quantityInput.min = min;

        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute('max');
        }
        this.quantityInput.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;

        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        return fetch(`${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
          })
          .catch((e) => console.error(e))
          .finally(() => this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden'));
      }

      updateQuantityRules(sectionId, html) {
        if (!this.quantityInput) return;
        this.setQuantityBoundries();

        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }

      get productForm() {
        return this.querySelector(`product-form`);
      }

      get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.section}`);
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        return this.querySelector('variant-selects');
      }

      get relatedProducts() {
        const relatedProductsSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'related-products'
        );
        return document.querySelector(`product-recommendations[data-section-id^="${relatedProductsSectionId}"]`);
      }

      get quickOrderList() {
        const quickOrderListSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'quick_order_list'
        );
        return document.querySelector(`quick-order-list[data-id^="${quickOrderListSectionId}"]`);
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    }
  );
}
